"use client"
import React, { useEffect, useRef, useState } from "react";
import styles from "./accordion.module.scss";
import Modal from "../Modal/Modal";

export interface Props {
    title: string;
    children?: React.ReactNode;
    text?: string;
    className?: string;
    closeTranslation: string;
}

export default function InformationBubble({ title, children, text, className, closeTranslation }: Props) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleModal = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className={`${className}`}>
            <div
                className={`relative`}
            >
                {/* Bubble Button */}
                <div
                    className="w-6 h-6 border border-gs-grey  bg-gs-light-blue rounded-full flex items-center justify-center cursor-pointer text-base font-bold"
                    onClick={toggleModal}
                    title={title}
                >
                    i
                </div>
                {isExpanded && (
                    <Modal
                        isOpen={isExpanded}
                        onClose={() => setIsExpanded(false)}
                        closeTranslation={closeTranslation}
                        className="max-w-[400px]"
                    >
                        <>
                            {!text && children && (
                                <>
                                    {children}
                                </>
                            )}

                            {text && !children && (
                                <div className="text-sm">
                                    <span>
                                        {text}
                                    </span>
                                </div>
                            )}
                        </>
                    </Modal>
                )}
            </div>
        </div>
    );
}
